import { Link } from "react-router-dom";

// components
import { Alert } from "@trussworks/react-uswds";

// styles
import styles from "./NotificationBanner.module.scss";

export default function NotificationBanner() {
	return (
		<div className="notification-banner">
			<Alert type="warning" headingLevel="h2" className={styles["alert-root"]}>
				<p className={styles["alert-heading"]}><strong>Small Business Search Notifications</strong></p>
				<ul className={styles["alert-list"]}>
					<li>
						<strong>The only legitimate SBA phone number related to Certifications is <a href="tel:1-866-722-4357">1-866-SBA-HELP</a>.</strong> “Certify.us” is not affiliated with SBA. SBA will not demand documents or information by email related to this Small Business Search (SBS) website, including capability statements. SBA will not charge a cost for Small Business Search (SBS) content or profile management.
					</li>
					<li>
						Effective August 1, 2025, <strong>VOSB and SDVOSB joint venture designations will no longer be reflected in SBS</strong>. <Link to="https://sbaone.atlassian.net/wiki/external/MzY1YTczZGM3NGM0NGNlZDg1Y2I2YTU1YTY1NTdiZTA" rel="noopener noreferrer" target="_blank">Click here to learn more</Link>.
					</li>
				</ul>
			</Alert>
		</div>
	);
}